import React from 'react';
import { MessageSquare } from 'lucide-react';

interface OGChatbotProps {
  appUrl?: string;
  position?: 'bottom-right' | 'bottom-left';
}

export function OGChatbot({ 
  appUrl,
  position = 'bottom-right' 
}: OGChatbotProps) {
  const baseUrl = appUrl || (import.meta.env.MODE === 'development' 
    ? 'http://localhost:3001' 
    : 'https://hvga-og.vercel.app');

  console.log('Current environment:', import.meta.env.MODE);
  console.log('Base URL:', baseUrl);

  const handleChatClick = () => {
    const returnUrl = window.location.href;
    const fullUrl = `${baseUrl}?return=${encodeURIComponent(returnUrl)}`;
    console.log('Opening URL:', fullUrl);
    
    // Check if device is mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile) {
      // For mobile devices, use location.href
      window.location.href = fullUrl;
    } else {
      // For desktop, use window.open
      window.open(fullUrl, '_blank');
    }
  };

  // Position styles
  const getPositionStyles = () => {
    return position === 'bottom-right' 
      ? { right: '40px' }
      : { left: '20px' };
  };

  return (
    <div className="fixed z-[9999]" style={{ bottom: '20px', ...getPositionStyles() }}>
      {/* Chat Bubble */}
      <button
        onClick={handleChatClick}
        className="w-15 h-15 bg-primary-600 text-white rounded-full p-4 shadow-lg hover:bg-primary-700 transition-transform hover:scale-110 flex items-center justify-center"
        aria-label="Open chat"
      >
        <MessageSquare className="w-6 h-6" />
      </button>
    </div>
  );
}